/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  FreeTextAnswer,
  FreeTextAnswerCreatePayloadRequest,
  FreeTextAnswerUpdatePayloadRequest,
  ValidationErrorResponse,
} from '../models';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FreeTextAnswerFromJSON,
    FreeTextAnswerToJSON,
    FreeTextAnswerCreatePayloadRequestFromJSON,
    FreeTextAnswerCreatePayloadRequestToJSON,
    FreeTextAnswerUpdatePayloadRequestFromJSON,
    FreeTextAnswerUpdatePayloadRequestToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models';

export interface FreeTextAnswersCreateRequest {
    freeTextAnswerCreatePayloadRequest: FreeTextAnswerCreatePayloadRequest;
}

export interface FreeTextAnswersDestroyRequest {
    id: number;
}

export interface FreeTextAnswersListRequest {
    categoryId?: string;
    questionId?: string;
}

export interface FreeTextAnswersUpdateRequest {
    id: number;
    freeTextAnswerUpdatePayloadRequest: FreeTextAnswerUpdatePayloadRequest;
}

/**
 * 
 */
export class FreeTextAnswersApi extends runtime.BaseAPI {

    /**
     */
    async freeTextAnswersCreateRaw(requestParameters: FreeTextAnswersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FreeTextAnswer>> {
        if (requestParameters.freeTextAnswerCreatePayloadRequest === null || requestParameters.freeTextAnswerCreatePayloadRequest === undefined) {
            throw new runtime.RequiredError('freeTextAnswerCreatePayloadRequest','Required parameter requestParameters.freeTextAnswerCreatePayloadRequest was null or undefined when calling freeTextAnswersCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/free_text_answers/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FreeTextAnswerCreatePayloadRequestToJSON(requestParameters.freeTextAnswerCreatePayloadRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FreeTextAnswerFromJSON(jsonValue));
    }

    /**
     */
    async freeTextAnswersCreate(requestParameters: FreeTextAnswersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FreeTextAnswer> {
        const response = await this.freeTextAnswersCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async freeTextAnswersDestroyRaw(requestParameters: FreeTextAnswersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling freeTextAnswersDestroy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/free_text_answers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async freeTextAnswersDestroy(requestParameters: FreeTextAnswersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.freeTextAnswersDestroyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async freeTextAnswersListRaw(requestParameters: FreeTextAnswersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FreeTextAnswer>>> {
        const queryParameters: any = {};

        if (requestParameters.categoryId !== undefined) {
            queryParameters['categoryId'] = requestParameters.categoryId;
        }

        if (requestParameters.questionId !== undefined) {
            queryParameters['questionId'] = requestParameters.questionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/free_text_answers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FreeTextAnswerFromJSON));
    }

    /**
     */
    async freeTextAnswersList(requestParameters: FreeTextAnswersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FreeTextAnswer>> {
        const response = await this.freeTextAnswersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async freeTextAnswersUpdateRaw(requestParameters: FreeTextAnswersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FreeTextAnswer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling freeTextAnswersUpdate.');
        }

        if (requestParameters.freeTextAnswerUpdatePayloadRequest === null || requestParameters.freeTextAnswerUpdatePayloadRequest === undefined) {
            throw new runtime.RequiredError('freeTextAnswerUpdatePayloadRequest','Required parameter requestParameters.freeTextAnswerUpdatePayloadRequest was null or undefined when calling freeTextAnswersUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/free_text_answers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FreeTextAnswerUpdatePayloadRequestToJSON(requestParameters.freeTextAnswerUpdatePayloadRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FreeTextAnswerFromJSON(jsonValue));
    }

    /**
     */
    async freeTextAnswersUpdate(requestParameters: FreeTextAnswersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FreeTextAnswer> {
        const response = await this.freeTextAnswersUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
